<div class="tfa-setup">

  <!-- ── Header ──────────────────────────────────────────── -->
  <div class="tfa-setup__header" mat-dialog-title>
    <mat-icon class="tfa-setup__icon" color="warn">verified_user</mat-icon>
    <div>
      <h2 class="tfa-setup__title">{{ data.title }}</h2>
      <p class="tfa-setup__subtitle">{{ data.message }}</p>
    </div>
  </div>

  <!-- ── Phone form (before code is needed) ─────────────── -->
  <mat-dialog-content *ngIf="!sms_twofacode_needed">
    <div [formGroup]="SMSForm">
      <mat-form-field appearance="outline" class="tfa-setup__field" floatLabel="always">
        <mat-label>Cell phone number</mat-label>
        <mat-icon matPrefix>smartphone</mat-icon>
        <input
          matInput
          mask="000-000-0000"
          formControlName="phoneNumber"
          [readonly]="!!data.phoneNumber"
          placeholder="555-000-0000" />
        <mat-hint *ngIf="data.phoneNumber">
          Number registered during setup — send a code to confirm it.
        </mat-hint>
        <mat-error>A valid phone number is required.</mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <!-- ── Code verification (after SMS sent) ─────────────── -->
  <mat-dialog-content *ngIf="sms_twofacode_needed">
    <app-prompt-2fa-code
      [method]="'sms'"
      [title]="''"
      [message]="''"
      [email]="data.email"
      (cancel)="handleCancel($event)"
      (confirm)="handleConfirm($event)"
      (sendnewcode)="handleSendNewCode($event)">
    </app-prompt-2fa-code>
  </mat-dialog-content>

  <!-- ── Actions ────────────────────────────────────────── -->
  <mat-dialog-actions align="end" *ngIf="!sms_twofacode_needed">
    <button mat-flat-button color="warn" class="tfa-setup__send-btn"
            (click)="onSendCode($event)">
      <mat-icon>sms</mat-icon>
      Send verification code
    </button>
  </mat-dialog-actions>

</div>
